export default __webpack_public_path__ + "static/media/invoice-column-inactive.89dcc3de.svg";